import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { Section } from '../ui/Section';
import { useServices } from '../../hooks/useServices';
export function ServicesSection() {
  const {
    services
  } = useServices();
  // Track which full-width card we're on (to alternate layout direction)
  let fullWidthCount = 0;
  return <Section id="services" background="white" className="!pt-10 md:!pt-16" data-id="element-327">
      <div className="max-w-3xl mb-14" data-id="element-328">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold font-heading text-[#0C0C0C]" data-id="element-329">
          What we do
        </motion.h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-330">
        {services.map((service, index) => {
        const isFullWidth = index % 3 === 0;
        if (isFullWidth) fullWidthCount++;
        // Alternate full-width cards: odd = text-left/image-right, even = image-left/text-right
        const isReversed = isFullWidth && fullWidthCount % 2 === 0;
        if (isFullWidth) {
          // Full-width card — side by side layout
          return <motion.div key={service.id} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08
          }} className="md:col-span-2" data-id="element-331">
                <Link to={`/services/${service.slug}`} className="block group" data-id="element-332">
                  <div className={`bg-transparent border-2 border-gray-200 rounded-2xl p-6 md:p-8 flex flex-col ${isReversed ? 'md:flex-row-reverse' : 'md:flex-row'} gap-6 md:gap-8 min-h-[280px] transition-all duration-300 group-hover:bg-[#FF6600] group-hover:border-[#FF6600] group-hover:shadow-lg`} data-id="element-333">
                    {/* Text side */}
                    <div className="flex-1 flex flex-col justify-between" data-id="element-334">
                      <div data-id="element-335">
                        <h3 className="text-2xl md:text-3xl font-bold font-heading text-[#0C0C0C] mb-4 transition-colors duration-300 group-hover:text-white" data-id="element-336">
                          {service.title}
                        </h3>
                        <p className="text-gray-600 leading-relaxed text-base transition-colors duration-300 group-hover:text-white/85 line-clamp-4" data-id="element-337">
                          {service.description}
                        </p>
                      </div>
                      <div className="flex items-center gap-2 mt-6 text-[#FF6600] transition-colors duration-300 group-hover:text-white" data-id="element-338">
                        <span className="text-sm font-medium" data-id="element-339">Read More</span>
                        <div className="w-6 h-6 rounded-full border border-[#FF6600]/50 flex items-center justify-center transition-all duration-300 group-hover:border-white/50 group-hover:bg-white/15" data-id="element-340">
                          <ArrowUpRight className="w-3.5 h-3.5" data-id="element-341" />
                        </div>
                      </div>
                    </div>
                    {/* Image side */}
                    {service.image ? <div className="flex-1 rounded-xl overflow-hidden bg-gray-100 aspect-[3/1]" data-id="element-342">
                        <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-343" />
                      </div> : <div className="flex-1 rounded-xl bg-gray-50 aspect-[3/1] transition-colors duration-300 group-hover:bg-white/10" data-id="element-344" />}
                  </div>
                </Link>
              </motion.div>;
        }
        // Half-width card — stacked layout (text on top, image below)
        return <motion.div key={service.id} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="md:col-span-1" data-id="element-345">
              <Link to={`/services/${service.slug}`} className="block h-full group" data-id="element-346">
                <div className="bg-transparent border-2 border-gray-200 rounded-2xl p-6 md:p-8 flex flex-col h-full min-h-[420px] transition-all duration-300 group-hover:bg-[#FF6600] group-hover:border-[#FF6600] group-hover:shadow-lg" data-id="element-347">
                  <div className="flex-1" data-id="element-348">
                    <h3 className="text-2xl font-bold font-heading text-[#0C0C0C] mb-4 transition-colors duration-300 group-hover:text-white" data-id="element-349">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed text-base transition-colors duration-300 group-hover:text-white/85 line-clamp-4" data-id="element-350">
                      {service.description}
                    </p>
                  </div>
                  {/* Image */}
                  {service.image ? <div className="w-full aspect-[3/1] rounded-xl overflow-hidden bg-gray-100 mt-6" data-id="element-351">
                      <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-352" />
                    </div> : <div className="w-full aspect-[3/1] rounded-xl bg-gray-50 mt-6 transition-colors duration-300 group-hover:bg-white/10" data-id="element-353" />}
                  <div className="flex items-center gap-2 mt-5 text-[#FF6600] transition-colors duration-300 group-hover:text-white" data-id="element-354">
                    <span className="text-sm font-medium" data-id="element-355">Read More</span>
                    <div className="w-6 h-6 rounded-full border border-[#FF6600]/50 flex items-center justify-center transition-all duration-300 group-hover:border-white/50 group-hover:bg-white/15" data-id="element-356">
                      <ArrowUpRight className="w-3.5 h-3.5" data-id="element-357" />
                    </div>
                  </div>
                </div>
              </Link>
            </motion.div>;
      })}
      </div>
    </Section>;
}